export var space = {
    NONE: 0,
    XS: 2,
    S: 4,
    M: 8,
    L: 16,
    XL: 32,
    XXL: 64,
};
